import type { ComponentPropsWithoutRef } from 'react';
import { cn } from 'src/utils/cn';

export const Spacer = ({
  vertical,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'> & { vertical?: boolean }) => {
  return (
    <div
      className={cn(
        vertical && `mx-[0.75rem] h-full w-[0.1rem]`,
        !vertical && `my-[0.75rem] h-[0.1rem] w-full`,
        className
      )}
      {...props}
    />
  );
};
